/**
 * Space-free labels (a pasted URL, an id) longer than this are middle-truncated when rendered.
 * Prose labels are never truncated — they wrap like any other text.
 */
export const MAX_LINK_LABEL_LENGTH = 48;

/**
 * Shortens a link label from the middle, keeping both ends legible.
 *
 * The case this exists for is a URL used as its own label, which is what the Ask agent produces
 * when it links to a filtered view: a few hundred characters of query string with nowhere to
 * wrap. The middle is the least informative part of a URL, so that is what goes.
 *
 * A label with a space in it is prose somebody wrote, and prose wraps. Only an unbroken run is
 * shortened, because that is the one nobody chose the length of.
 */
export function truncateLinkLabel(label: string, maxLength = MAX_LINK_LABEL_LENGTH): string {
  if (label.length <= maxLength || /\s/.test(label)) {
    return label;
  }

  const head = Math.ceil((maxLength - 1) * 0.7);
  const tail = maxLength - 1 - head;
  return `${label.slice(0, head)}…${label.slice(label.length - tail)}`;
}
